"use client";
import { ASSET_PREFIX } from "../../../config";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import {
  sampleCeo,
  sampleExecs,
  sampleHeads,
  SplitHero,
} from "./LeadershipSection";

/* ---------------- Data ---------------- */
const faqItems = [
  {
    question: "Sky Garden",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "Waterproofing",
          "Engineered drainage",
          "Nutrient-retaining biofabric layer",
          "Drip irrigation",
          "Seating deck, lighting, and plumbing",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    question: "Home Automation",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "Voice-Controlled Home Automation",
          "Future-ready infrastructure",
          "Voice intercom between rooms",
          "Remote Controlled BLDC fans",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    question: "Modular Kitchen ",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "Furnished Kitchen",
          "Furnished Bathrooms",
          "Lights & Fans",
          "Premium Interior Finishes",
          "Power Backup",
          "EV Charging Provision",
          "AC in all Bedrooms",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    question: "Space Optimizing Furniture",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "Multi-Purpose Living Dining Space",
          "Foldable Dining cum Cutlery unit",
          "Ceiling Mounted TV unit (Integrated to Living cum Dining)",
          "TV/AV Room cum Bedroom",
          "Built-In Study cum Workspace",
          "Family Lounge with Optional Bed",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    question: "Centralized Vacuum System",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "Concealed vacuum system",
          "Centralized",
          "Noise-free",
          "Dust stored and collected outside",
          "Easy hassle-free plug & play cleaning",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    question: "Solar Power",
    answer: (
      <ul className="grid gap-[12px] sm:gap-[8px]">
        {[
          "6kVA solar panels",
          "Automatic cleaning sprinklers",
          "Sustainable Energy - Live Net Zero",
        ].map((item, idx) => (
          <li
            key={idx}
            className="flex items-start gap-[10px] group hover:text-[#b08d38] transition duration-300 ease-in-out">
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              className="transition-transform duration-300 group-hover:rotate-45 mt-[5px] min-w-[22px]">
              <path
                d="M15.435 1.565c0-.552-.448-1-1-1H5.435a1 1 0 0 0-1 1c0 .553.448 1 1 1H13.435V10.565c0 .552.448 1 1 1s1-.448 1-1V1.565ZM1 15l.707.707L15.142 2.272 14.435 1.565 13.728.858.293 14.293 1 15Z"
                fill="#b08d38"
              />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    ),
  },
];

/* ---------------- Component ---------------- */
export default function OverviewRev() {
  const items = faqItems;

  // “+ Effect” collapsible
  const [showMore, setShowMore] = useState(false);
  const effectRef = useRef<HTMLDivElement>(null);
  const [effectMaxH, setEffectMaxH] = useState("0px");
  useEffect(() => {
    if (effectRef.current)
      setEffectMaxH(showMore ? `${effectRef.current.scrollHeight}px` : "0px");
  }, [showMore]);

  // Shared state: donut + accordion
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  // Refs for accordion content panels (for measuring height)
  const containerRefs = useRef<Array<HTMLDivElement | null>>([]);
  const contentRefs = useRef<Array<HTMLDivElement | null>>([]);

  // Recalculate heights on resize so open panel stays correct
  useEffect(() => {
    let rAF: number | null = null;
    const onResize = () => {
      if (rAF) cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() =>
        setOpenIndex((idx) => (idx === null ? null : idx))
      );
    };
    window.addEventListener("resize", onResize);
    return () => {
      if (rAF) cancelAnimationFrame(rAF);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const handleSliceClick = (i: number) => {
    setOpenIndex(i);
    const el = containerRefs.current[i];
    // If you want scroll on mobile: el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="">
      {/* ---------- About ---------- */}
      {/* <div className="w-[85%] mx-auto">
        <h2 className="text-[26px] leading-[32px] md:text-[28px]/[36px] lg:text-[30px]/[38px] xl:text-[32px]/[40px] 2xl:text-[35px]/[42px] text-[#000] font-[600] tracking-[-0.03em] mb-[20px] sm:mb-[25px]">
          Where everyone builds Villa, we built +Willa - WHY?
        </h2>
        <p className="text-[18px] leading-[26px] sm:text-[20px]/[28px] md:text-[20px]/[28px] xl:text-[22px]/[30px] 2xl:text-[24px]/[32px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
          Find Out Why on November 3<sup>rd</sup>
        </p>
      </div> */}

      {/* <div className="w-[85%] mx-auto grid grid-cols-1 md:grid-cols-[50%_45%] lg:grid-cols-[45%_50%] xl:grid-cols-[40%_50%] justify-between gap-[35px] md:gap-[50px] items-center pt-[40px] md:pt-[50px] xl:pt-[65px] mt-[35px] md:mt-[45px] xl:mt-[60px] relative  pt-0! mt-0!">
        <div className="w-[100%] sm:w-[90%] xl:w-[80%]">
          <h3 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] tracking-[-0.03em] mb-[25px] sm:mb-[30px] md:mb-[40px] font-[600]">
            A New Definition of Moving In
          </h3>
          <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
            Moving into a home shouldn’t mean months of setup and decision
            fatigue. At +Willa, everything is solved for you - from furniture to
            fixtures, automation to aesthetics.
          </p>
          <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
            Each villa is fully equipped and meticulously crafted to ensure you
            can truly{"  "}
            <span className="text-[18px] leading-[23px] font-semibold">
              To Experience +Willa!
            </span>
          </p>
          <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
            Every square foot is planned with precision, every detail reflects
            intent - creating a living experience that’s seamless, sustainable,
            and strikingly simple.
          </p>
        </div>
        <div className="overflow-hidden">
          <Image
            src={`${ASSET_PREFIX}/images/pluswilla-building-elevation.webp`}
            alt="PlusWilla Building Elevation"
            className="w-full md:w-auto h-[200px] sm:h-[280px] md:h-[380px] object-cover object-center hover:scale-[1.5] transition duration-700 ease-in-out"
            width={1200}
            height={800}
            priority
            unoptimized
          />
        </div>
        <div className="absolute bottom-auto top-[28px] md:top-auto md:bottom-[-27px] right-[-20px] sm:right-[-37px] md:right-[-60px] xl:right-[-80px] 2xl:right-[-100px] scale-x-[1]">
          <Image
            src={`${ASSET_PREFIX}/images/icons/pluswilla.svg`}
            alt="Pluswilla"
            width={425}
            height={100}
            className="w-[230px] sm:w-[300px] md:w-[425px] h-auto"
            priority
          />
        </div>
      </div>*/}
      <div className="w-[85%] mx-auto  max-w-[130rem] mx-auto">
        <h4 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] mb-[30px] md:mb-[50px] text-center tracking-[-0.03em]">
          Leadership
        </h4>
      </div>
      <div className="mx-auto max-w-7xl   w-[85%]">
        <SplitHero
          ceo={sampleCeo}
          executives={sampleExecs}
          functionalHeads={sampleHeads}
        />
      </div>
      <div className="px-[8%] py-[40px] md:py-[50px] xl:py-[65px] mt-[60px] md:mt-[60px] xl:mt-[100px] border-t border-[#00000066] relative bg-[#ECE5DF]">
        <h3 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] font-[600] text-[#000] font-[500] tracking-[-0.03em] mb-[25px] sm:mb-[30px] md:mb-[40px]">
          Built by Unitd Living Space
        </h3>
        <div className=" grid grid-cols-1 md:grid-cols-[50%_45%] lg:grid-cols-[45%_50%] xl:grid-cols-[40%_50%] justify-between gap-[0] sm:gap-[10px] md:gap-[50px] items-start ">
          {/* <div className="overflow-hidden">
          <Image
            src={`${ASSET_PREFIX}/images/ship-img.webp`}
            alt=""
            className="w-full md:w-auto h-[auto] sm:h-[auto] md:h-[auto] object-cover object-center hover:scale-[1.05] transition duration-700 ease-in-out"
            width={1200}
            height={800}
            priority
            unoptimized
          />
        </div> */}
          {/* <div className="overflow-hidden">
          <Image
            src={`${ASSET_PREFIX}/images/plus-willa-map-loacations.webp`}
            alt=""
            className="w-full md:w-auto h-[200px] sm:h-[280px] md:h-[380px] object-cover object-center hover:scale-[1.5] transition duration-700 ease-in-out"
            width={1200}
            height={800}
            priority
            unoptimized
          />
        </div>
        <div className="absolute bottom-auto top-[28px] md:top-auto md:bottom-[-27px] left-[-20px] sm:left-[-37px] md:left-[-60px] xl:left-[-80px] 2xl:left-[-100px] scale-x-[-1]">
          <Image
            src={`${ASSET_PREFIX}/images/icons/pluswilla.svg`}
            alt=""
            width={425}
            height={100}
            className="w-[230px] sm:w-[300px] md:w-[425px] h-auto"
            priority
          />
        </div> */}
          <div className="w-[100%] sm:w-[90%] xl:w-[80%]">
            <h3 className="text-[20px] leading-[28px]   md:text-[20px] md:leading-[28px]   xl:text-[22px] xl:leading-[30px]   2xl:text-[24px] 2xl:leading-[32px] text-[#000]  mb-[15px] ">
              A Parent Brand that Never Stops Solving
            </h3>
            <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
              Unitd Living Space isn’t just a developer - we’re innovators,
              problem-solvers, and visionaries.
            </p>
            <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
              With over 25 years of experience, we go beyond construction to
              create ecosystems that redefine how people live.
            </p>
          </div>

          {/* <div className="w-[100%] sm:w-[90%] xl:w-[80%]">
          <h3 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] tracking-[-0.03em] mb-[25px] sm:mb-[30px] md:mb-[40px]">
            Every +Willa is finished, functional, and future-ready, powered by
            The +Effect - so life begins the moment you move in.
          </h3>
          <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]"></p>
        </div> */}
          <div className="w-[100%] sm:w-[90%] xl:w-[80%]">
            <h3 className="text-[20px] leading-[28px]   md:text-[20px] md:leading-[28px]   xl:text-[22px] xl:leading-[30px]   2xl:text-[24px] 2xl:leading-[32px] text-[#000]  mb-[15px]  ">
              Our ecosystem powers two distinct living solutions:
            </h3>
            <ul className="my-[30px]">
              <li className="grid gap-[10px] grid-cols-[20px_auto] my-[15px] items-center">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="https://www.w3.org/2000/svg">
                  <path
                    d="M4.36783 16.2162C6.04375 13.5794 7.03023 10.0703 7.04695 6.47255C7.06563 2.41358 5.78705 0.00887961 3.78755 2.79644e-05C1.68674 -0.0098072 0.290139 2.57487 0.267518 7.39706C0.251782 10.9112 0.891072 13.9935 2.02901 16.233C1.65527 17.0926 0.828127 17.7387 0 18.0485L0.665846 19.932C1.55889 19.4176 2.37423 18.7409 3.11187 17.9C4.17506 19.214 5.4979 19.9536 6.98499 19.9605L7.61837 19.9634L7.62821 17.8754C7.62821 17.8754 5.25005 18.0584 4.36685 16.2162M2.01131 7.21412C2.02606 3.8623 2.72633 2.2572 3.73739 2.26212C4.70813 2.26703 5.31496 3.7964 5.30316 6.43911C5.28939 9.35622 4.54486 12.1592 3.28595 14.3859C2.46274 12.531 1.9995 10.0211 2.01229 7.21412"
                    fill="black"></path>
                  <path
                    d="M12.3295 16.2529C14.0054 13.6161 14.9919 10.1069 15.0086 6.50917C15.0273 2.4502 13.7497 0.0455007 11.7502 0.0366491C9.64939 0.0268139 8.2518 2.6115 8.23017 7.43368C8.21443 10.9478 8.85372 14.0301 9.99166 16.2696C9.61792 17.1292 8.79077 17.7754 7.96265 18.0852L8.62849 19.9686C9.52153 19.4542 10.3369 18.7776 11.0745 17.9366C12.1377 19.2506 13.4605 19.9902 14.9476 19.9971L15.581 20.0001L15.5909 17.9121C15.5909 17.9121 13.2127 18.095 12.3295 16.2529ZM9.97395 7.24976C9.98871 3.89794 10.689 2.29284 11.7 2.29775C12.6708 2.30267 13.2776 3.83204 13.2658 6.47475C13.252 9.39186 12.5075 12.1949 11.2486 14.4216C10.4254 12.5667 9.96215 10.0567 9.97494 7.24976"
                    fill="black"></path>
                </svg>
                <span>
                  <b>MultiUtility Homes (MUH)</b> - Space-maximized urban
                  apartments.
                </span>
              </li>
              <li className="grid gap-[10px] grid-cols-[20px_auto] my-[8px] items-center">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="https://www.w3.org/2000/svg">
                  <path
                    d="M4.36783 16.2162C6.04375 13.5794 7.03023 10.0703 7.04695 6.47255C7.06563 2.41358 5.78705 0.00887961 3.78755 2.79644e-05C1.68674 -0.0098072 0.290139 2.57487 0.267518 7.39706C0.251782 10.9112 0.891072 13.9935 2.02901 16.233C1.65527 17.0926 0.828127 17.7387 0 18.0485L0.665846 19.932C1.55889 19.4176 2.37423 18.7409 3.11187 17.9C4.17506 19.214 5.4979 19.9536 6.98499 19.9605L7.61837 19.9634L7.62821 17.8754C7.62821 17.8754 5.25005 18.0584 4.36685 16.2162M2.01131 7.21412C2.02606 3.8623 2.72633 2.2572 3.73739 2.26212C4.70813 2.26703 5.31496 3.7964 5.30316 6.43911C5.28939 9.35622 4.54486 12.1592 3.28595 14.3859C2.46274 12.531 1.9995 10.0211 2.01229 7.21412"
                    fill="black"></path>
                  <path
                    d="M12.3295 16.2529C14.0054 13.6161 14.9919 10.1069 15.0086 6.50917C15.0273 2.4502 13.7497 0.0455007 11.7502 0.0366491C9.64939 0.0268139 8.2518 2.6115 8.23017 7.43368C8.21443 10.9478 8.85372 14.0301 9.99166 16.2696C9.61792 17.1292 8.79077 17.7754 7.96265 18.0852L8.62849 19.9686C9.52153 19.4542 10.3369 18.7776 11.0745 17.9366C12.1377 19.2506 13.4605 19.9902 14.9476 19.9971L15.581 20.0001L15.5909 17.9121C15.5909 17.9121 13.2127 18.095 12.3295 16.2529ZM9.97395 7.24976C9.98871 3.89794 10.689 2.29284 11.7 2.29775C12.6708 2.30267 13.2776 3.83204 13.2658 6.47475C13.252 9.39186 12.5075 12.1949 11.2486 14.4216C10.4254 12.5667 9.96215 10.0567 9.97494 7.24976"
                    fill="black"></path>
                </svg>
                <span>
                  <b>+Willa</b>- Pre-equipped, ready-to-live villas.
                </span>
              </li>
            </ul>
            <p className="text-[16px]/[24px] md:text-[18px]/[26px] text-[#000] font-[400] mb-[20px] tracking-[-0.03em]">
              Together, they embody one unified philosophy:
              <span className="text-[18px] leading-[23px] font-semibold">
                Solve better. Build smarter. Live sustainably.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ---------- Donut v3 (matches final-design.svg reference) ---------- */
function Donut({
  items,
  activeIndex,
  onSelect,
}: {
  items: string[];
  activeIndex: number;
  onSelect: (idx: number) => void;
}) {
  // geometry
  const size = 640;
  const cx = size / 2;
  const cy = size / 2;

  // ring radii tuned to the reference
  const R_OUTER = 242;
  const R_GLASS_TOP = 250; // faint outer rim/glow guide
  const R_INNER = 118;
  const R_INSET_1 = R_INNER + 12; // thin inner slot ring
  const R_INSET_2 = R_INNER + 26; // thick luminous dashes
  const R_LABEL = 205;

  const SLICE_GAP = 4;
  const START = -90;
  const per = 360 / items.length;

  const toRad = (d: number) => (d * Math.PI) / 180;
  const polar = (r: number, aDeg: number) => {
    const a = toRad(aDeg);
    return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
  };
  const donutPath = (
    rOuter: number,
    rInner: number,
    a0: number,
    a1: number
  ) => {
    const large = a1 - a0 > 180 ? 1 : 0;
    const p0 = polar(rOuter, a0);
    const p1 = polar(rOuter, a1);
    const q1 = polar(rInner, a1);
    const q0 = polar(rInner, a0);
    return [
      `M ${p0.x} ${p0.y}`,
      `A ${rOuter} ${rOuter} 0 ${large} 1 ${p1.x} ${p1.y}`,
      `L ${q1.x} ${q1.y}`,
      `A ${rInner} ${rInner} 0 ${large} 0 ${q0.x} ${q0.y}`,
      "Z",
    ].join(" ");
  };
  const arcPath = (r: number, a0: number, a1: number) => {
    const large = a1 - a0 > 180 ? 1 : 0;
    const p0 = polar(r, a0);
    const p1 = polar(r, a1);
    return `M ${p0.x} ${p0.y} A ${r} ${r} 0 ${large} 1 ${p1.x} ${p1.y}`;
  };

  // slices
  const slices = items.map((title, i) => {
    const a0 = START + i * per + SLICE_GAP / 2;
    const a1 = START + (i + 1) * per - SLICE_GAP / 2;
    const mid = (a0 + a1) / 2;
    const lbl = polar(R_LABEL, mid);
    const rot = mid + 90;
    const txtRot = rot > 90 && rot < 270 ? rot + 180 : rot;
    return {
      i,
      title,
      a0,
      a1,
      mid,
      d: donutPath(R_OUTER, R_INNER, a0, a1),
      labelX: lbl.x,
      labelY: lbl.y,
      txtRot,
    };
  });

  const active = activeIndex >= 0 ? slices[activeIndex] : null;

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      className="w-full h-full"
      width={size}
      height={size}>
      <defs>
        {/* ambient vignette */}
        <radialGradient id="halo" cx="50%" cy="50%">
          <stop offset="65%" stopColor="rgba(0,0,0,0)" />
          <stop offset="100%" stopColor="rgba(0, 0, 0, 0)" />
        </radialGradient>

        {/* glass base + active tint */}
        <linearGradient id="glass" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.07" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.03" />
        </linearGradient>
        <linearGradient id="glassActive" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.16" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.10" />
        </linearGradient>

        {/* glossy inner ring */}
        <linearGradient id="ringHi" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(0, 0, 0, 0)" stopOpacity="0.25" />
          <stop offset="100%" stopColor="rgba(0, 0, 0, 0)" stopOpacity="0.0" />
        </linearGradient>

        {/* inner shadow for depth */}
        <filter id="innerShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="6" result="b" />
          <feComposite operator="out" in="SourceGraphic" in2="b" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0
                    0 0 0 0 0
                    0 0 0 0 0
                    0 0 0 0.55 0"
          />
          <feBlend in="SourceGraphic" />
        </filter>

        {/* soft spotlight beams for active slice */}
        <radialGradient id="beam" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor="rgba(255, 255, 255, 0)" />
          <stop offset="55%" stopColor="rgba(255, 255, 255, 0)" />
          <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
        </radialGradient>

        {/* glow for dashes/slots */}
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.5" result="g" />
          <feMerge>
            <feMergeNode in="g" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        {/* clip just the active wedge for the beam */}
        {active && (
          <clipPath id="clipActive">
            <path
              d={donutPath(R_GLASS_TOP + 8, R_INNER - 12, active.a0, active.a1)}
            />
          </clipPath>
        )}
      </defs>

      {/* background vignette */}
      <circle cx={cx} cy={cy} r={R_GLASS_TOP + 60} fill="url(#halo)" />

      {/* faint outer rim (like the reference) */}
      <circle
        cx={cx}
        cy={cy}
        r={R_GLASS_TOP}
        fill="none"
        stroke="rgba(255, 255, 255, 0)"
        strokeWidth={2}
      />

      {/* faint quadrant guide arcs */}
      {Array.from({ length: 4 }).map((_, q) => {
        const a0 = START + q * 90 + 16;
        const a1 = a0 + 90 - 32;
        return (
          <path
            key={`q-${q}`}
            d={arcPath(R_GLASS_TOP - 4, a0, a1)}
            fill="none"
            stroke="rgba(255, 255, 255, 0)"
            strokeWidth={2}
            strokeLinecap="round"
          />
        );
      })}

      {/* radial separators */}
      {slices.map((s, i) => {
        const p0 = polar(R_INNER - 8, s.a0);
        const p1 = polar(R_OUTER + 10, s.a0);
        return (
          <line
            key={`sep-${i}`}
            x1={p0.x}
            y1={p0.y}
            x2={p1.x}
            y2={p1.y}
            stroke="rgba(255, 255, 255, 0)"
            strokeWidth={1}
          />
        );
      })}

      {/* wedges with subtle zoom/glow on active */}
      {slices.map((s) => {
        const isActive = s.i === activeIndex;
        const transform = isActive
          ? `translate(${cx} ${cy}) scale(1.06) translate(${-cx} ${-cy})`
          : undefined;
        return (
          <g
            key={s.i}
            onClick={() => onSelect(s.i)}
            className="cursor-pointer transition duration-1000"
            style={{ transition: "transform 220ms ease, filter 220ms ease" }}
            transform={transform}
            radius={30}
            filter={isActive ? "url(#innerShadow)" : undefined}>
            <path
              d={s.d}
              fill={isActive ? "url(#glassActive)" : "url(#glass)"}
              radius={30}
              stroke={
                isActive ? "rgba(255,255,255,0.28)" : "rgba(255,255,255,0.18)"
              }
              strokeWidth={1}
            />
          </g>
        );
      })}

      {/* active beams (clipped to active wedge) */}
      {active && (
        <g clipPath="url(#clipActive)" pointerEvents="none">
          <circle cx={cx} cy={cy} r={R_GLASS_TOP + 20} fill="url(#beam)" />
        </g>
      )}

      {/* glossy inner ring + etched rings */}
      <path
        d={donutPath(R_INNER + 34, R_INNER + 18, -180, 180)}
        fill="url(#ringHi)"
        opacity={0}
      />
      <circle
        cx={cx}
        cy={cy}
        r={R_INNER + 8}
        fill="none"
        stroke="rgba(255, 255, 255, 0)"
        strokeWidth={1}
      />
      <circle
        cx={cx}
        cy={cy}
        r={R_INNER + 30}
        fill="none"
        stroke="rgba(0, 0, 0, 0)"
        strokeWidth={1}
      />

      {/* luminous inner dashes */}
      {Array.from({ length: 4 }).map((_, k) => {
        const a0 = -65 + k * 90;
        const a1 = a0 + 40;
        return (
          <path
            key={`dash-${k}`}
            d={arcPath(R_INSET_2, a0, a1)}
            fill="none"
            stroke="rgba(0, 0, 0, 0)"
            strokeWidth={12}
            strokeLinecap="round"
            filter="url(#glow)"
          />
        );
      })}

      {/* thin rim slots (shorter, closer to center) */}
      {Array.from({ length: 4 }).map((_, k) => {
        const a0 = -22 + k * 90;
        const a1 = a0 + 16;
        return (
          <path
            key={`slot-${k}`}
            d={arcPath(R_INSET_1, a0, a1)}
            fill="none"
            stroke="rgba(255, 255, 255, 0)"
            strokeWidth={6}
            strokeLinecap="round"
            filter="url(#glow)"
          />
        );
      })}

      {/* center recess + rim */}
      <circle cx={cx} cy={cy} r={R_INNER - 8} fill="#0e0e10" opacity={0} />
      <circle
        cx={cx}
        cy={cy}
        r={R_INNER - 14}
        fill="none"
        stroke="rgba(255,255,255,0.18)"
        strokeWidth={2}
      />

      {/* CENTER LOCKUP - swap to your SVG if needed */}
      <g transform={`translate(${cx}, ${cy})`} pointerEvents="none">
        {/* Example: image logo (preferred). Replace src with your asset */}
        {/* <image href={`${ASSET_PREFIX}/images/+willa-lockup.svg`} x={-82} y={-28} width={164} height={56} /> */}
        {/* Fallback text lockup */}
        <text
          x="0"
          y="-4"
          textAnchor="middle"
          fill="rgba(0, 0, 0, 0)"
          fontWeight={700}
          fontSize="0"
          style={{ letterSpacing: "0.5px" }}></text>
        <text
          x="0"
          y="24"
          textAnchor="middle"
          fill="rgba(0, 0, 0, 0)"
          fontSize="0"
          style={{ letterSpacing: "2px" }}>
          {/* with in-built */}
        </text>
      </g>

      {/* labels */}
      {slices.map((s) => (
        <g
          key={`lbl-${s.i}`}
          onClick={() => onSelect(s.i)}
          className="cursor-pointer"
          transform={`translate(${s.labelX}, ${s.labelY}) rotate(${s.txtRot})`}>
          <foreignObject x={-110} y={-16} width={220} height={32}>
            {/* <div
              className={`w-full h-full flex items-center justify-center text-[14px] md:text-[15px] font-semibold ${
                s.i === activeIndex ? "text-white" : "text-white/90"
              }`}
              style={{
                textShadow:
                  s.i === activeIndex
                    ? "0 0 8px rgba(255,255,255,0.55)"
                    : "none",
                letterSpacing: "-0.01em",
                userSelect: "none",
              }}>
              {s.title}
            </div> */}
          </foreignObject>
        </g>
      ))}
    </svg>
  );
}
